import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8.03518 10C8.03518 8.89695 8.91456 8.00062 9.9986 8.00062C11.0826 8.00062 11.962 8.89695 11.962 10C11.962 11.1032 11.0826 11.9995 9.9986 11.9995C8.91459 11.9995 8.03518 11.1032 8.03518 10Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.42452 0H12.5718L12.7898 1.11557L12.7905 1.11938L13.1491 2.89995C13.6605 3.12982 14.1348 3.41442 14.5734 3.73654L16.366 3.12563L17.4285 2.79011L17.9834 3.75974L19.4329 6.23204L20 7.22322L19.1555 7.97359L17.811 9.13932C17.8532 9.40099 17.8923 9.69638 17.8923 9.99996C17.8923 10.3036 17.8532 10.599 17.811 10.8607L19.1615 12.0317L20 12.7768L19.4293 13.774L17.9835 16.24L17.4285 17.2123L16.3523 16.8698L14.5734 16.2635C14.1348 16.5856 13.6605 16.8701 13.1491 17.1L12.7905 18.8805L12.7898 18.8843L12.5718 20H7.4245L7.20851 18.8819L6.84859 17.1001C6.33712 16.8702 5.86278 16.5856 5.42407 16.2635L3.63276 16.8739L2.56802 17.2127L2.01497 16.2395L0.563968 13.7668L0 12.7768L0.842006 12.0264L2.18699 10.8603C2.14493 10.5993 2.10516 10.3028 2.10516 9.99996C2.10516 9.69717 2.14492 9.40067 2.18699 9.13974L0.835275 7.96768L2.8399e-05 7.22321L0.568269 6.22566L2.01515 3.76021L2.56803 2.7898L3.64524 3.13014L5.42407 3.73654C5.86276 3.41437 6.3371 3.12973 6.84859 2.89985L7.20852 1.11797L7.42452 0ZM9.9986 6.66648C8.19249 6.66648 6.72624 8.15927 6.72624 10C6.72624 11.8408 8.19246 13.3337 9.9986 13.3337C11.8047 13.3337 13.271 11.8408 13.271 10C13.271 8.15927 11.8047 6.66648 9.9986 6.66648Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const CogIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  CogIcon as default
};
//# sourceMappingURL=CogIcon.vue.es.js.map
